import React, { Component } from "react";
import { Auth, API } from "aws-amplify";
import LoaderButton from "./LoaderButton";

function waitForInit() {
  return new Promise((res, rej) => {
    const hasFbLoaded = () => {
      if (window.FB) {
        res();
      } else {
        setTimeout(hasFbLoaded, 300);
      }
    };
    hasFbLoaded();
  });
}

export default class FacebookButton extends Component {
  constructor(props) {
    super(props);
    //this.fbLoginEvent.bind(this);
    this.fbLoginErrorEvent.bind(this);
    this.state = {
      isLoading: true,
      accessToken: null,
      tokenExpiration: null
    };
  }

  //   async fbLoginEvent(data) {
  //     this.props.onLogin(data);
  //   }
  async fbLoginErrorEvent(error) {
    this.props.onLoginError({
      message: "Unable to login with Facebook, please try again.(" + error + ")"
    });
  }
  async componentDidMount() {
    await waitForInit();
    this.setState({ isLoading: false });
  }

  handleFBLoginResult = response => {
    console.log("handleFBLoginResult", response);
    if (response.status === "connected") {
      this.handleFBResponse(response);
    } else {
      this.fbLoginErrorEvent(response.status);
    }
  };

  handleClick = async event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    window.FB.login(this.handleFBLoginResult, {
      scope: "public_profile,email,user_friends",
      fields: "name,email,picture,friends,birthday",
      return_scopes: true
    });
  };

  handleFBResponse = async fbResponse => {
    console.log("handleResponse", fbResponse);
    const data = fbResponse.authResponse;
    this.setState({ accessToken: data.accessToken });
    var username = "";
    var email = "";
    const { accessToken: token, expiresIn } = data;
    const expires_at = expiresIn * 1000 + new Date().getTime();

    //var self = this;

    //window.FB.api('/me?fields=name,email,friends', this.fbProfile, expiresIn);
    await window.FB.api(
      "/me?fields=name,email,picture,birthday",
      async function(response) {
        //await window.FB.api('/me/friends?fields=name,email,picture', async (response) => {
        console.log("FB Me inside handleResponse:", response);

        //temporary add mine
        //response.friends.data = [{email:'abraham.vargas@gmail.com', name:"Abraham Vargas", userid:"us-east-1:ffb4972a-0a25-4edc-9bda-08f3fd388ec9"},{email:'abraham.vargas2@gmail.com', name:"Abraham Vargas Fake", userid:"us-east-1:90aca84d-9c35-4cb2-a570-ae403937ca36"}];
        //localStorage.setItem('friendList', JSON.stringify(response.friends.data));

        username = response.name;
        email = response.email;
        const bodyLogin = {
          body: {
            email: email,
            picture:
              "https://graph.facebook.com/" +
              response.id +
              "/picture?type=large",
            providerId: "FB" + response.id
          }
        };
        console.log("body login :", bodyLogin);
        console.log("Log user.");
        const newuser = {
          name: username,
          email: email,
          picture:
            "https://graph.facebook.com/" + response.id + "/picture?type=large"
        };
        console.log("Username:", newuser);
        const federatedResponse = await Auth.federatedSignIn(
          "facebook",
          { token, expires_at },
          newuser
        );
        let responseLogin = await API.post("books", "user/login", bodyLogin);

        const storedUser = {
          email: response.email,
          userName: response.name,
          picture: bodyLogin.body.picture,
          providerId: "FB" + response.id
        };
        localStorage.setItem("LoginUser", JSON.stringify(storedUser));

        console.log("user/login response: ", responseLogin);
        if (responseLogin.status) {
          console.log("signin:", federatedResponse);
          await window.FB.api(
            "/me/friends?fields=name,email,picture",
            async friendsResponse => {
              console.log("FB friendsResponse:", friendsResponse);
              localStorage.setItem(
                "friendList",
                JSON.stringify(friendsResponse.data)
              );
              localStorage.setItem(
                "friendCountPrevious",
                localStorage.getItem("friendCountTotal")
              );
              localStorage.setItem(
                "friendCountTotal",
                friendsResponse.data.length
              );
            }
          );
          this.fbLoginEvent(federatedResponse);
        } else {
          const storedUser = {
            email: response.email,
            userName: response.name,
            picture: bodyLogin.body.picture,
            providerId: "FB" + response.id
          };
          localStorage.setItem("LoginUser", JSON.stringify(storedUser));
          var errorMessage = responseLogin.message;

          if (responseLogin.message.indexOf("User not signed") >= 0) {
            errorMessage += " Please Signup to continue.";
          } else if (responseLogin.message.indexOf("Terms not accepted") >= 0) {
            errorMessage +=
              " Please accept new Terms of Conditions to continue.";
          }
          this.props.onLoginError({ message: errorMessage, link: "/signup" });
        }
        this.setState({ isLoading: false });
      }
    );
  };

  render() {
    return (
      <LoaderButton
        block
        bsSize="large"
        bsStyle="primary"
        className="FacebookButton"
        text="Login with Facebook"
        onClick={this.handleClick}
        disabled={this.state.isLoading}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FacebookButton.js